import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { isDesktop } from '@zola-helpers/client/dist/es/util/responsive';

import { trackNavigationClicked } from 'util/trackingHelper';
import Logo from 'assets/images/navigation/zola-logo.svg';

const NavLogo = ({ className, section, logo = Logo }) => {
  const onClick = (e) => {
    e.stopPropagation();
    const eventData = {
      menu_item: 'ZOLA',
      section,
      node_level_1: 'ZOLA',
      row_position: 1,
      column_position: 1,
    };

    // TODO: fire for all screen sizes when click tracking is added to the mobile nav
    if (isDesktop()) trackNavigationClicked(eventData);
  };

  return (
    <div className={cx('nav-logo', className)}>
      <a
        href="/"
        target="_self"
        aria-label="Zola Homepage"
        onClick={onClick}
        data-testid="nav-logo"
      >
        <img src={logo} alt="Zola Homepage" className="nav-logo__img" />
      </a>
    </div>
  );
};

NavLogo.propTypes = {
  className: PropTypes.string,
  section: PropTypes.string,
  logo: PropTypes.string,
};

export default NavLogo;
